import React, { useEffect, useLayoutEffect, useState } from "react";
import Mocion from "../../assets/icons/MocionBlue.svg";
import image from "../../assets/images/image 86.png";
import { useNavigate } from "react-router-dom";
import { useGetMyProfileQuery } from "../../lib/redux/services/sections/Profile";
import { useDispatch } from "react-redux";
import { setUser } from "../../lib/redux/slices/userSlice";
const FirstScreen = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string | null>(
    localStorage.getItem("token")
  );
  localStorage.setItem("theme", "light");
  const { data, isFetching, isSuccess } = useGetMyProfileQuery("", {
    skip: !token,
  });
  useLayoutEffect(() => {
    //const token = localStorage.getItem("token");
    const timer = setTimeout(() => {
      if (token && data) {
        console.log("from first screen");
        // dispatch(setUser(data.data))

        if (data.data.status == "Active") navigate("/home?viewType=weekly");
        else navigate("/club-settings/organization");
      } else if (!isFetching) {
        navigate("/auth/welcome");
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate, token, data, isFetching, isSuccess]);
  return (
    <div className="relative flex items-center justify-center h-dvh">
      {/* Background Image */}
      <img loading="lazy"
        src={image}
        alt="Background"
        className="absolute inset-0 w-full h-full object-cover z-0"
      />

      {/* Overlay   */}
      <div className="absolute inset-0 bg-[rgba(203,219,42,0.89)] z-10"></div>

      {/* Logo */}
      <img loading="lazy" src={Mocion} alt="Logo" className="relative w-[400px] h-52 z-20" />
    </div>
  );
};

export default FirstScreen;
